<template>
  <div :class="['rt-divider', `rt-divider-${direction}`,{'rt-divider-dashed':dashed}]">
  </div>
</template>

<script>
export default {
  name: 'RtDivider',
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator (val) {
        return ['horizontal', 'vertical'].indexOf(val) !== -1;
      }
    },
    dashed: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// rtDivider.vue?71151770